<template>
	<div class="copyright">
		<div>Copyright @ 1971-{{ currentYear }} 江阴市尚时工程装备有限公司 版权所有. </div>
		<div class="beiAn">
			<img src="../../assets/ssjt/img/beian.png">&nbsp;
			<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32028102001173" target="_blank">苏公网安备32028102001173号</a>&nbsp;
			<a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2021027656号-1</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "Copyright",
	data() {
		return{
			currentYear: 1971
		}
	},
	methods: {
		getCurrentYear(){
			this.currentYear = new Date().getFullYear();
		}
	},
	mounted() {
		this.getCurrentYear();
	}
}
</script>

<style scoped>
	@media (max-width: 767px){ .copyright{ width: 100%; } }
	@media (min-width: 768px){ .copyright{ width: 1080px; } }
	.copyright{ color: #93979a; margin: auto; text-align: center; font-size: 12px; }
	a{ color: #93979a; text-decoration: none; transition: all 0.2s linear; }
	a:hover{ color: #c2ccd0; }
	.beiAn{ margin-top: 2px; display: block; vertical-align: middle; }
	.beiAn>img{ height: 16px; vertical-align: bottom; }
</style>